// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2S3KX","footer":"ChangeClinic_footer__3lT9Z"};